import { Dropdown, IconButton, Tooltip } from '@billy/design-system'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SalesReportDisplayOptions } from './elements/SalesReportDisplayOptions'

const DROPDOWN_WIDTH = 260

export const SalesReportDisplaySettings = () => {
  const { t } = useTranslation()
  const [shouldHideTooltip, setShouldHideTooltip] = useState(false)

  const handleDropdownOpen = () => {
    setShouldHideTooltip(true)
  }

  const handleDropdownClose = () => {
    setShouldHideTooltip(false)
  }

  return (
    <Tooltip
      forceHidden={shouldHideTooltip}
      label={t('sales_report.sales_overview.display_options.title')}
      placement="left"
    >
      <Dropdown
        placement="bottom-end"
        trigger={<IconButton icon="settings" variant="outlined" />}
        width={DROPDOWN_WIDTH}
        onOpen={handleDropdownOpen}
        onClose={handleDropdownClose}
      >
        <SalesReportDisplayOptions />
      </Dropdown>
    </Tooltip>
  )
}
